type Environment = "dev" | "ppe" | "prod" | "local";

type ClientConfig = {
  endpoint: string;
  instrumentationKey: string;
  webChatTokenEndpoint: string;
};

type ClientConfigs = {
  [key in Environment]: ClientConfig;
};

// Power Virtual Agents / Copilot Studio Direct Line token endpoints.
//
// We have two Power Platform environments wired up:
//   * dining-agent-prod  — production bot, SSO via Microsoft Entra ID.
//   * dining-agent-ppe   — non-prod bot, SSO via Microsoft Entra ID.
//
// The dining-agent-sandbox env is a Copilot Studio authoring environment
// that does NOT have the SSO connection registered, so the web SDK cannot
// open a Direct Line conversation against it. As a result, **every** non-prod
// SPA build (local / dev / ppe) points at dining-agent-ppe — that's the
// closest-to-prod target with a working auth handshake.
//
// Hostname pattern:
//   https://<first-30-hex-of-env-id>.<last-2-hex-of-env-id>.environment.api.powerplatform.com
// To find a new env's URL: open https://copilotstudio.microsoft.com → switch
// to the target environment → bot → Settings → Channels → Custom website.
const WEBCHAT_TOKEN_URL_SANDBOX =
  "https://70e09792fa19e4ca846a6048195d8b.1c.environment.api.powerplatform.com/powervirtualagents/botsbyschema/copilots_header_82780/directline/token?api-version=2022-03-01-preview";
const WEBCHAT_TOKEN_URL_PPE =
  "https://b889a05122a6e60eafa909da31db68.00.environment.api.powerplatform.com/powervirtualagents/botsbyschema/copilots_header_82780/directline/token?api-version=2022-03-01-preview";

const WEBCHAT_TOKEN_URL_PROD =
  "https://bd1b6249ed3ee15cbf9502272a5b16.0e.environment.api.powerplatform.com/powervirtualagents/botsbyschema/copilots_header_82780/directline/token?api-version=2022-03-01-preview";

const clientConfigs: ClientConfigs = {
  prod: {
    endpoint: "https://prod-dining-api-frontdoor.azurefd.net",
    instrumentationKey: "7c931884-62a0-49ec-8875-f4a5869219bd",
    webChatTokenEndpoint: WEBCHAT_TOKEN_URL_PROD,
  },
  ppe: {
    endpoint: "https://ppe-dining-api-frontdoor.azurefd.net",
    instrumentationKey: "c232118a-911c-4470-8744-2d8ee6c8f1db",
    webChatTokenEndpoint: WEBCHAT_TOKEN_URL_PPE,
  },
  dev: {
    endpoint: "https://dev-dining-api-frontdoor.azurefd.net",
    instrumentationKey: "7c6f8a96-029a-4cd2-8d20-7227d5f061a9",
    webChatTokenEndpoint: WEBCHAT_TOKEN_URL_SANDBOX,
  },
  local: {
    endpoint: "https://dev-dining-api-frontdoor.azurefd.net",
    instrumentationKey: "7c6f8a96-029a-4cd2-8d20-7227d5f061a9",
    webChatTokenEndpoint: WEBCHAT_TOKEN_URL_SANDBOX,
  },
};

export const config: ClientConfig = {
  endpoint: clientConfigs[(process.env.APP_ENV as Environment) || "dev"].endpoint,
  instrumentationKey:
    clientConfigs[(process.env.APP_ENV as Environment) || "dev"].instrumentationKey,
  webChatTokenEndpoint:
    clientConfigs[(process.env.APP_ENV as Environment) || "dev"].webChatTokenEndpoint,
};
